Vue.component('LoginPage', require('./components/LoginPage').default);
Vue.component('BInputRoles', require('./components/BInputRoles').default);
Vue.component('LoginFormComponent', require('./components/LoginFormComponent').default);
Vue.component('ResetPasswordFormComponent', require('./components/ResetPasswordFormComponent').default);
Vue.component('RoleIndexComponent', require('./components/RolesIndexComponent').default);
Vue.component('RoleGetComponent', require('./components/RolesFormComponent').default);

Vue.component('RolesSelector', require('./components/partials/RolesSelector').default);
Vue.component('UserIndexComponent', require('./components/UsersIndexComponent').default);
Vue.component('UserGetComponent', require('./components/UsersFormComponent').default);
Vue.component('BaseUserForm', require('./components/BaseUserForm').default);
Vue.component('RecoveryLinkForm', require('./components/RecoveryLinkForm').default);
Vue.component('RecoveryLinkSent', require('./components/RecoveryLinkSent').default);

Vue.component('LoginCarousel', require('./components/LoginCarousel').default);

Vue.component('AvatarComponent', require('./components/AvatarComponent').default);

Vue.component('QuickHelpComponent', require('./components/QuickHelpComponent').default);
Vue.component('AddEmailRemainder', require('./components/AddEmailRemainder').default);
Vue.component('BConfirm', require('../../../bgo-components/resources/js/components/BConfirm').default);

// Vue.component('user-preview-component', require('./components/UserPreviewComponent').default);

Vue.component('DmsRolesFormActions', require('./components/partials/DmsRolesFormActions').default);
Vue.component('DmsRolesTabs', require('./components/partials/DmsRolesTabs').default);
Vue.component('DmsRolesTabsItems', require('./components/partials/DmsRolesTabsItems').default);
Vue.component('DmsRolesTabsItems', require('./components/partials/DmsRolesTabsItems').default);
Vue.component('DmsRolesDetails', require('./components/partials/DmsRolesDetails').default);
Vue.component('DmsRolesPermissions', require('./components/partials/DmsRolesPermissions').default);
